export const Icon = ({ name, size = 20, fill = false, className }: { name: string; size?: number; fill?: boolean; className?: string }) => (
  <span aria-hidden className={`msr ${className ?? ''}`} style={{ fontSize: size, fontVariationSettings: fill ? "'FILL' 1" : undefined }}>{name}</span>
);
